import PropTypes from 'prop-types';
import { progressBarStepPropTypes } from '../../../propTypes';

export const labelsPropTypes = PropTypes.shape({
  congratulationsText: PropTypes.string,
  bookingReferenceText: PropTypes.string,
  paymentReferenceText: PropTypes.string,
  noAgentCodeText: PropTypes.string,
});

export const acknowledgementLoadPropTypes = PropTypes.shape({
  agentCode: PropTypes.string,
  errorCode: PropTypes.number,
  errorMessage: PropTypes.string,
  leadBookerName: PropTypes.string,
  productId: PropTypes.string,
  productName: PropTypes.string,
  productPrice: PropTypes.string,
  productQuantity: PropTypes.number,
  productVariant: PropTypes.string,
  progressBarSteps: PropTypes.arrayOf(progressBarStepPropTypes),
  totalAmount: PropTypes.number,
  transactionReference: PropTypes.string,
});
